import { z } from 'zod'
import { KaskoDocument } from '~/shared/api'
import { Option } from '~/shared/config/constants'
import { stringRequiredScheme } from '~/shared/lib/schemas'

export const formSchema = KaskoDocument.schema
  .pick({
    series: true,
    number: true,
    issuedDate: true,
    expirationDate: true,
    counterpartyId: true,
  })
  .extend({
    number: stringRequiredScheme,
  })

export type TypeFormSchema = z.infer<typeof formSchema>

export type FormValues = Omit<TypeFormSchema, 'counterpartyId'> & {
  counterpartyId: UniqueId | Option | null
}
